import { render, staticRenderFns } from "./DisposeDetail.vue?vue&type=template&id=19eaa207&scoped=true&"
import script from "./DisposeDetail.vue?vue&type=script&lang=js&"
export * from "./DisposeDetail.vue?vue&type=script&lang=js&"
import style0 from "./DisposeDetail.vue?vue&type=style&index=0&id=19eaa207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eaa207",
  null
  
)

export default component.exports